import React from 'react';
import { KanbanSquare, LayoutTemplate, Sparkles, Settings2, Users, MessagesSquare, MessageCircleMore, TrendingUp, Landmark, ScanBarcode, Target, BadgeCheck, LayoutGrid, FolderOpen, Boxes, Building, ShoppingCart, Banknote, Store, Mail, LayoutDashboard, Megaphone } from 'lucide-react';

const DEFS = {
  dashboard: { Icon: LayoutDashboard, chip: 'bg-[rgba(37,99,235,0.12)]', color: 'text-blue-700' },
  apps: { Icon: LayoutGrid, chip: 'bg-[rgba(27,42,107,0.10)]', color: 'text-[hsl(var(--pillot-navy))]' },
  documents: { Icon: FolderOpen, chip: 'bg-[rgba(234,179,8,0.14)]', color: 'text-yellow-700' },
  website: { Icon: LayoutTemplate, Extra: Sparkles, chip: 'bg-[rgba(34,197,171,0.16)]', color: 'text-[hsl(var(--pillot-mint))]' },
  settings: { Icon: Settings2, chip: 'bg-[rgba(27,42,107,0.10)]', color: 'text-[hsl(var(--pillot-navy))]' },
  contacts: { Icon: Users, chip: 'bg-[rgba(14,165,233,0.12)]', color: 'text-sky-700' },
  pesan: { Icon: MessageCircleMore, chip: 'bg-[rgba(34,197,171,0.16)]', color: 'text-[hsl(var(--pillot-mint))]' },
  discuss: { Icon: MessagesSquare, chip: 'bg-[rgba(245,158,11,0.14)]', color: 'text-amber-700' },
  sales: { Icon: TrendingUp, chip: 'bg-[rgba(34,197,94,0.12)]', color: 'text-emerald-700' },
  purchasing: { Icon: ShoppingCart, chip: 'bg-[rgba(249,115,22,0.12)]', color: 'text-orange-700' },
  accounting: { Icon: Landmark, chip: 'bg-[rgba(59,130,246,0.12)]', color: 'text-blue-700' },
  pos: { Icon: ScanBarcode, chip: 'bg-[rgba(244,63,94,0.12)]', color: 'text-rose-700' },
  crm: { Icon: Target, chip: 'bg-[rgba(99,102,241,0.12)]', color: 'text-indigo-700' },
  inventory: { Icon: Boxes, chip: 'bg-[rgba(168,85,247,0.12)]', color: 'text-purple-700' },
  assets: { Icon: Building, chip: 'bg-[rgba(120,113,108,0.14)]', color: 'text-stone-700' },
  hr: { Icon: BadgeCheck, chip: 'bg-[rgba(20,184,166,0.12)]', color: 'text-teal-700' },
  ecommerce: { Icon: Store, chip: 'bg-[rgba(234,88,12,0.12)]', color: 'text-orange-700' },
  email_marketing: { Icon: Megaphone, chip: 'bg-[rgba(225,29,72,0.12)]', color: 'text-rose-700' },
  webmail: { Icon: Mail, chip: 'bg-[rgba(2,132,199,0.12)]', color: 'text-sky-700' },
  project: { Icon: KanbanSquare, chip: 'bg-[rgba(15,118,110,0.12)]', color: 'text-teal-800' },
  pillot_pay: { Icon: Banknote, chip: 'bg-[rgba(16,185,129,0.14)]', color: 'text-emerald-700' },
};

export const ModuleIcon = ({ moduleKey, size = 'md', className = '' }) => {
  const def = DEFS[moduleKey] || DEFS.settings;
  const { Icon, Extra } = def;
  const dims = size === 'lg' ? 'h-16 w-16 rounded-2xl' : size === 'sm' ? 'h-8 w-8 rounded-lg' : 'h-12 w-12 rounded-2xl';
  const iconSize = size === 'lg' ? 30 : size === 'sm' ? 16 : 24;
  return (
    <div className={`relative flex items-center justify-center ${dims} ${def.chip} ${className}`}>
      <Icon size={iconSize} strokeWidth={2} className={def.color} />
      {Extra && <Extra size={iconSize * 0.45} className={`absolute -top-1 -right-1 ${def.color}`} strokeWidth={2.4} />}
    </div>
  );
};

export const LOGO_URL = '/pillot-logo.png';
export const LOGO_FULL_URL = '/pillot-logo-full.png';
export const ICON_URL = '/pillot-icon.png';

export const PillotLogo = ({ className = 'h-7', withTagline = false }) => (
  <img src={withTagline ? LOGO_FULL_URL : LOGO_URL} alt="Pillot" className={`${className} w-auto object-contain`} data-testid="pillot-logo" />
);
